import { initializeFirebase, getFirebaseAuth } from '@heyroot/auth-shared';

import { env } from '../env';

export function initFirebase(): void {
  initializeFirebase({
    apiKey: env.FIREBASE_API_KEY,
    authDomain: env.FIREBASE_AUTH_DOMAIN,
    projectId: env.FIREBASE_PROJECT_ID,
    // Local dev: route the Auth SDK at the Firebase Auth emulator (unset in
    // prod). Stays on import.meta.env deliberately -- it is never set in a
    // container, the one sanctioned exception to the env.ts chokepoint.
    authEmulatorUrl: import.meta.env['VITE_FIREBASE_AUTH_EMULATOR_HOST'],
  });
  const tenantId = env.CIP_TENANT_ID;
  if (tenantId) getFirebaseAuth().tenantId = tenantId; // route to the admin CIP tenant
}
